import React, { useState } from "react";
import { UploadCloud, FolderUp } from "lucide-react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PDFBuilder() {
  const [text, setText] = useState("");
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [textColor, setTextColor] = useState("#0000ff");
  const [role, setRole] = useState("Member"); 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleImageUpload = (e) => {
    setImages([...images, ...Array.from(e.target.files)]);
  };

  const handleVideoUpload = (e) => {
    setVideos([...videos, ...Array.from(e.target.files)]);
  };


const handleGeneratePDF = async () => {
  const formData = new FormData();
  const token = localStorage.getItem("token");
  const societyName = localStorage.getItem("society");

  if (!token || !societyName) {
    toast.error("Token or society not found ❌");
    return;
  }


  if (images[0] && images[0].size > 20 * 1024 * 1024) {
    toast.error("Please upload image under 20MB ❌");
    return;
  }


  if (videos[0] && videos[0].size > 20 * 1024 * 1024) {
    toast.error("Please upload video under 20MB ❌");
    return;
  }

  formData.append("welcomeText", text);
  formData.append("societyName", societyName);
  formData.append("role", role || "Member");
  formData.append("textColor", textColor);

  if (images.length > 0) {
    formData.append("backgroundImage", images[0]);
  }

  if (videos.length > 0) {
    formData.append("backgroundVideo", videos[0]);
  }

  try {
    const res = await fetch(`${BASE_URL}/welcome/add-welcome`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    let data = null;

    try {
      data = await res.json(); 
    } catch {
      console.warn("No JSON from server");
    }

    if (res.ok) {
      toast.success("Upload Successful ");
      console.log(data);
    } else {
      toast.error("Server error ");
      console.error(data);
    }
  } catch (error) {
    toast.error("Network error ");
    console.error(error);
  }
};


  const handleSaveRole = async () => {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");

    if (!token || !societyName) {
      alert("Token or society not found ❌");
      return;
    }

    const formData = new FormData();
    formData.append("role", role);
    formData.append("societyName", societyName);

    try {
      const res = await fetch(`${BASE_URL}/welcome/add-welcome`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await res.json();

      if (res.ok) {
        alert("Role saved successfully ✅");
        console.log("Saved role:", data);
      } else {
        alert("Failed to save role ❌");
        console.error(data);
      }
    } catch (error) {
      alert("Error saving role ❌");
      console.error(error);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="app-container h-screen flex flex-col">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout flex flex-1 overflow-hidden">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area flex-1 overflow-y-auto">
          <SubHeader />
          <div className="flex justify-center items-center border-b pb-4"></div>
          <div className="h-full bg-white text-gray-900 p-6 overflow-y-auto">
            <div className="h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="col-span-1 flex flex-col gap-4">
                <div className="border rounded-xl p-4">
                  <div className="border rounded-xl p-4 mb-4">
                    <h2 className="text-lg font-medium text-blue-600 mb-2">
                      Role
                    </h2>

                    <select
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                      className="w-full p-2 border rounded mb-3"
                    >
                      <option value="Member">Member</option>
                      <option value="Employee">Employee</option>
                       <option value="Noc">Noc</option>
                      <option value="Complaints">Complaints</option>
                    </select>
                  </div>

                  <h2 className="text-lg font-medium text-blue-600 mb-2">
                    Text Content
                  </h2>

                  <textarea
                    className="w-full p-3 rounded-lg border focus:ring-2 focus:ring-blue-300 outline-none h-40"
                    placeholder="Start writing your document..."
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                  />
                </div>

                {/* Buttons */}
                <div className="flex gap-4 mt-2">
                  <button
                    onClick={handleGeneratePDF}
                    className="flex items-center justify-center gap-2 min-w-[160px] px-6 py-3 rounded-lg 
                    bg-blue-600 text-white font-medium tracking-wide 
                    border border-blue-500 shadow-sm 
                    hover:bg-blue-700 hover:shadow-md 
                    active:scale-[0.98] transition-all duration-200"
                  >
                    <UploadCloud size={18} className="opacity-90" />
                    IMPORT
                  </button>

                  <button
                    onClick={() => navigate("/welcome-management")}
                    className="flex items-center justify-center gap-2 min-w-[160px] px-6 py-3 rounded-lg 
                    bg-blue-600 text-white font-medium tracking-wide 
                    border-blue-500 shadow-sm 
                    hover:bg-blue-700 hover:shadow-md 
                    active:scale-[0.98] transition-all duration-200"
                  >
                    <FolderUp size={18} className="opacity-90" />
                    All Upload
                  </button>
                </div>
              </div>

              {/* Images Column */}
              <div className="col-span-1 flex flex-col gap-4">
                <div className="border rounded-xl p-4">
                  <h2 className="text-lg font-medium text-blue-600 mb-2">
                    Images
                  </h2>

                  <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageUpload}
                  />

                  <div className="grid grid-cols-2 gap-2 mt-3">
                    {images.map((img, i) => (
                      <img
                        key={i}
                        src={URL.createObjectURL(img)}
                        alt="preview"
                        className="rounded-lg h-24 object-cover border"
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Videos Column */}
              <div className="col-span-1 flex flex-col gap-4">
                <div className="border rounded-xl p-4">
                  <h2 className="text-lg font-medium text-blue-600 mb-2">
                    Videos
                  </h2>

                  <input
                    type="file"
                    multiple
                    accept="video/*"
                    onChange={handleVideoUpload}
                  />

                  <div className="space-y-2 mt-3">
                    {videos.map((vid, i) => (
                      <video
                        key={i}
                        src={URL.createObjectURL(vid)}
                        controls
                        className="rounded-lg w-full max-h-40 border"
                      />
                    ))}
                  </div>
                 <h2 className="text-lg font-medium text-blue-600 mb-2">
  Text Color
</h2>

<div className="flex gap-2">
  {/* Color Picker */}
  <input
    type="color"
    value={textColor}
    onChange={(e) => setTextColor(e.target.value)}
    className="h-10 w-16 border rounded cursor-pointer"
  />

  {/* Text Input (color name or hex) */}
  <input
    type="text"
    value={textColor}
    onChange={(e) => setTextColor(e.target.value)}
    placeholder="Enter color (e.g. red or #ff0000)"
    className="flex-1 p-2 border rounded"
  />
</div>
                  
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}